module.exports = __webpack_public_path__ + "img/contactus_normal.7b7ace73.png";